import React from 'react';
import { Autocomplete, Box, TextField } from '../../utils/globalImports';

type CustomSearchableDropdownProps<T> = {
  id?: string;
  label?: string;
  placeholder?: string;
  options: T[];
  value: T | null;
  getOptionLabel: (option: T) => string;
  isOptionEqualToValue?: (option: T, value: T) => boolean;
  onChange: (value: T | null) => void;
  size?: 'small' | 'medium';
  disabled?: boolean;
  loading?: boolean;
  sx?: any;
};

function CustomSearchableDropdown<T = any>({
  id,
  label,
  placeholder,
  options,
  value,
  getOptionLabel,
  isOptionEqualToValue,
  onChange,
  size = 'small',
  disabled = false,
  loading = false,
  sx,
}: CustomSearchableDropdownProps<T>) {
  return (
    <Autocomplete
      id={id}
      size={size}
      sx={{ ...sx }}
      options={options || []}
      autoHighlight
      getOptionLabel={getOptionLabel as any}
      value={value as any}
      isOptionEqualToValue={isOptionEqualToValue as any}
      onChange={(_, newValue) => onChange(newValue as any)}
      disabled={disabled}
      loading={loading}
      renderOption={(props, option: any) => {
        const { key, ...optionProps } = props as any;
        return (
          <Box key={key} component="li" {...optionProps}>
            {getOptionLabel(option)}
          </Box>
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          slotProps={{
            htmlInput: {
              ...params.inputProps,
              autoComplete: 'new-password',
            },
          }}
        />
      )}
    />
  );
}

export default CustomSearchableDropdown;
